interface Props {
  /** Share of the circle to fill, between 0 and 1. */
  fraction: number;
  color: string;
  backgroundColor: string;
  size?: number;
}

/**
 * Decorative pie showing a fraction. Hidden from assistive technology,
 * so always pair it with text that states the same value.
 */
const ProgressCircle: React.FC<Props> = ({
  fraction,
  color,
  backgroundColor,
  size = 20,
}) => {
  const clamped = Math.min(Math.max(fraction, 0), 1);
  const center = size / 2;
  // A circle stroked as wide as its diameter renders as a pie slice.
  const radius = size / 4;
  const circumference = 2 * Math.PI * radius;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      aria-hidden="true"
      focusable="false"
      style={{ flexShrink: 0 }}
    >
      <circle cx={center} cy={center} r={center} fill={backgroundColor} />
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke={color}
        strokeWidth={center}
        strokeDasharray={`${clamped * circumference} ${circumference}`}
        transform={`rotate(-90 ${center} ${center})`}
      />
    </svg>
  );
};

export default ProgressCircle;
